import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { templates } from "src/assets/templates-email";
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class InstitutionalService {

	constructor(private http: HttpClient) { }
	API_URL = environment.ApiUrl;
	ApiKey = environment.ApiKey;
	/* -------        INSTITUTIONAL               -------*/
	newInstitution(institution, token) {
		const formInstitution = new FormData();
		let headers = new HttpHeaders();

		formInstitution.append("name", institution.institution.toString());
		formInstitution.append("period_start", institution.period_start.toString());
		formInstitution.append("period_end", institution.period_end.toString());

		if (institution.picture) {
			formInstitution.append("picture", institution.picture);
			formInstitution.append("watermark", institution.picture);
		}

		formInstitution.append("basic_users", institution.users_basic.toString());
		formInstitution.append("pro_users", institution.users_pro.toString());
		formInstitution.append("manager_name", institution.full_name.toString());
		formInstitution.append("email", institution.email.toString());
		formInstitution.append("password", institution.password.toString());

		headers = headers.append('Authorization', `Bearer ${token}`);

		return this.http.post(`${this.API_URL}institutions/create`, formInstitution, {
			headers: headers,
		});
	}

	templatesHTML = templates;
	verifyUserFromAdmin(email, link_access) {
		const form = new FormData();
		const headers = new HttpHeaders();

		form.append("email", email.toString());
		form.append("link_access", link_access.toString());
		

		return this.http.post(`${this.API_URL}users/resendEmailVerification`, form, {
			headers: headers,
		});
	}

	getInstitutionByID(token, id_institution) {
		let headers = new HttpHeaders();
		
		headers = headers.append('Authorization', `Bearer ${token}`);
        
		return this.http.get(
			`${this.API_URL}institutions/getbyid/${id_institution}`,
			{
				headers: headers,
			}
		);
	}

    getInstitutionLogo(id_institution, image){
        //return `http://localhost:8080/uploads/institutions/${id_institution}/${image}`
		return `${this.API_URL}uploads/institutions/${id_institution}/${image}`
	}

	editInstitution(token, id_institution, institution) {
		const formInstitution = new FormData();
		let headers = new HttpHeaders();

		formInstitution.append("id_institution", id_institution.toString());
		formInstitution.append("name", institution.institution.toString());
		if (institution.picture) {
			formInstitution.append("picture", institution.picture);
			formInstitution.append("watermark", institution.picture);
		}
		formInstitution.append("period_start", institution.period_start.toString());
		formInstitution.append("period_end", institution.period_end.toString());
		formInstitution.append("basic_users", institution.users_basic.toString());
		formInstitution.append("pro_users", institution.users_pro.toString());

		
		headers = headers.append('Authorization', `Bearer ${token}`);

		return this.http.post(`${this.API_URL}institutions/edit`, formInstitution, {
			headers: headers,
		});
	}

	editWaterMark(token, id_institution, watermark){
		const formInstitution = new FormData();
		let headers = new HttpHeaders();
		formInstitution.append("_id", id_institution.toString());
		formInstitution.append("watermark", watermark);
		


		headers = headers.append('Authorization', `Bearer ${token}`);

		return this.http.post(`${this.API_URL}edit_institution`, formInstitution, {
			headers: headers,
		});	
	}

    createPreRegister(token, id_institution, user){
		const formUser = new FormData();
		let headers = new HttpHeaders();

		formUser.append("id_institution", id_institution.toString());
		formUser.append("id_plan", user.id_plan.toString());
		formUser.append("email", user.email.toString());
		formUser.append("full_name", user.full_name.toString());
    
		headers = headers.append('Authorization', `Bearer ${token}`);

		return this.http.post(`${this.API_URL}preregistrations/create`, formUser, {
			headers: headers,
		});
	}

	newPreRegister(token, id_institution, id_pricing_plan, user){
		const formUser = new FormData();
		let headers = new HttpHeaders();

		formUser.append("id_institution", id_institution.toString());
		formUser.append("id_pricing_plan", id_pricing_plan.toString());

		formUser.append("email", user.email.toString());
		formUser.append("code", user.code.toString());
		formUser.append("full_name", user.full_name.toString());
		formUser.append("subject", user.subject.toString());
		formUser.append("welcome_message", user.welcome_message.toString());
		formUser.append("message", user.message.toString());
		formUser.append("title_code", user.title_code.toString());
		formUser.append("button_message", user.button_message.toString());
		formUser.append("lang", user.lang.toString());
		formUser.append("link_access", user.link_access.toString());
		formUser.append("template",this.templatesHTML.preRegister);

		
		headers = headers.append('Authorization', `Bearer ${token}`);

		return this.http.post(`${this.API_URL}new_pre_registration`, formUser, {
			headers: headers,
		});
	}

	temportalApiError = "http://localhost:8080/v1/ezzenotes?endpoint=";
	getPreRegistrationsByType(limit, page, id_institution, filter, token){
		//id_type  idbasicplan, idproplan, all => basic, pro,todos
		let headers = new HttpHeaders();
		headers = headers.append('Authorization', `Bearer ${token}`);

		const body = new FormData();
        
        body.append("id_institution", id_institution.toString());
        body.append("limit", limit);
        body.append("page", page);
		
        if(filter == 'registered'){
            body.append("registered", 'true');
        }else if(filter != 'all'){
            body.append("id_plan", filter);
        }

        return this.http.post(`${this.API_URL}preregistrations/list`, body, {headers: headers});
	}//PENDINGG SERVER
	searchPreRegisters(id_institution, search, token){
		let headers = new HttpHeaders();
		
		headers = headers.append('Authorization', `Bearer ${token}`);
        const body = new FormData();
        
        body.append("id_institution", id_institution.toString());
        body.append("search_pattern", search);

        return this.http.post(`${this.API_URL}preregistrations/list`, body, {headers: headers});
	}//PENDINGG SERVER

	deletePreregister(id_preregister, token){
		let headers = new HttpHeaders();
		headers = headers.append('Authorization', `Bearer ${token}`);

		return this.http.delete(
			`${this.API_URL}preregistrations/delete/${id_preregister}`, {headers: headers}
		);
	}

	deleteInstitution(token, id_institution){
		let headers = new HttpHeaders();
		
		headers = headers.append('Authorization', `Bearer ${token}`);

		return this.http.delete(
			`${this.API_URL}institutions/delete/${id_institution}`,
			{
				headers: headers,
			}
		);
	}

	verifyEmailPreRegister(token, email){
		let headers = new HttpHeaders();
		
		headers = headers.append('Authorization', `Bearer ${token}`);

		return this.http.get(
			`${this.API_URL}verify_email&email=${email}`,
			{
				headers: headers,
			}
		);
	}

	editCountUsersInstitution(token, id_institution, countBasic, countPro) {
		const formInstitution = new FormData();
		let headers = new HttpHeaders();

		formInstitution.append("_id", id_institution.toString());
		formInstitution.append("users_basic_count", countBasic);
		formInstitution.append("users_pro_count", countPro);

		
		headers = headers.append('Authorization', `Bearer ${token}`);

		return this.http.post(`${this.API_URL}edit_institution_users_count`, formInstitution, {
			headers: headers,
		});
	}

	editInstitutionUserPlan(token, id_sub, id_plan){
		const formInstitution = new FormData();
		let headers = new HttpHeaders();

		formInstitution.append("_id", id_sub);
		formInstitution.append("id_pricing_plan", id_plan);

		
		headers = headers.append('Authorization', `Bearer ${token}`);

		return this.http.post(`${this.API_URL}edit_institution_user`, formInstitution, {
			headers: headers,
		});
	}

	editPreRegistration(token, id_pre, id_pricing_plan){
		const formPreReg = new FormData();
		let headers = new HttpHeaders();

		formPreReg.append("_id", id_pre);
		formPreReg.append("id_pricing_plan", id_pricing_plan);

		
		headers = headers.append('Authorization', `Bearer ${token}`);

		return this.http.post(`${this.API_URL}edit_pre_registration`, formPreReg, {
			headers: headers,
		});
		
	}

	removeUserOfInstitution(token, id_user){
		const formInstitution = new FormData();
		let headers = new HttpHeaders();

		formInstitution.append("_id", id_user.toString());
		formInstitution.append("id_institution", null);


		headers = headers.append('Authorization', `Bearer ${token}`);

		return this.http.post(`${this.API_URL}unlink_user_institution`, formInstitution, {
			headers: headers,
		});
	}

	removeSubUserOfInstitution(token, id_user){
		let headers = new HttpHeaders();
		
		headers = headers.append('Authorization', `Bearer ${token}`);

		return this.http.post(
			`${this.API_URL}remove_subscription_user_institution&_id=${id_user}`, null,
			{
				headers: headers,
			}
		);
	}

	deletePreRegistro(token, id_pre){
		let headers = new HttpHeaders();
		
		headers = headers.append('Authorization', `Bearer ${token}`);

		return this.http.post(
			`${this.API_URL}delete_pre_registration&_id=${id_pre}`, null,
			{
				headers: headers,
			}
		);
	}

	getUserbyId(token, id_user) {
		let headers = new HttpHeaders();
		
		//headers = headers.append('Token', token.toString());
		headers = headers.append('Authorization', `Bearer ${token}`);
		return this.http.get(`${this.API_URL}users/getbyid/${id_user}`, {
			headers: headers,
		});
	}
}
